<template>
  <el-dialog title="物流信息" width="40%" :modal="modal" :before-close="closeDialog" :visible.sync="isDialog">
    <div v-loading="loading" style="height: auto;max-height:500px;overflow-y: auto;" class="padding scroll-wrap">
      <template v-if="activities.length > 0">
        <el-timeline :reverse="true">
          <el-timeline-item v-for="(activity, index) in activities" :key="index"
            :icon="index == activities.length - 1 ? 'el-icon-more' : 'el-icon-check'"
            :color="index != activities.length - 1 ? '#0bbd87' : ''" :timestamp="activity.timestamp">
            {{ activity.content }}
          </el-timeline-item>
        </el-timeline>
      </template>
      <template v-else>
        <div class="text-center">{{ msg }}</div>
      </template>

    </div>
    <div slot="footer" class="dialog-footer" style="padding-top:0; padding-right: 20px;">
      <el-button @click="closeDialog">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'OrderRefund',
  components: {},
  props: {
    orderInfo: {
      type: Object,
      default: () => { }
    },
    dialogVisible: {
      type: Boolean,
      default() {
        return false
      }
    },
    modal: {
      type: Boolean,
      default() {
        return true
      }
    },
    id: {
      type: [Number, String],
      default: 0
    },
    row: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      isDialog: false,
      refund_money: '',
      activities: [],
      loading: true,
      msg: ''
    }
  },
  computed: {
    ...mapGetters(['config'])
  },
  watch: {
    dialogVisible: function (data) {
      this.isDialog = data
      if (this.orderInfo && data) this.init()
    },

  },
  methods: {

    init() {
      this.loading = true
      if (this?.row?.express_data?.State == 3) {
        this.activities = this.row.express_data.Traces.map(item => {
          return {
            content: item.AcceptStation,
            timestamp: item.AcceptTime,
            color: '#0bbd87'
          }
        })
        this.loading = false
        return
      }

      const index = this.orderInfo.express.findIndex(item => {
        return item.express_no == this.row.express_no;
      })
      console.log(index);
      const expressData = this.orderInfo.express[index];
      if (expressData && expressData.express_data && expressData.express_data.State == 3) {
        this.activities = expressData.express_data.Traces.reverse().map(item => {
          return {
            content: item.AcceptStation,
            timestamp: item.AcceptTime,
            color: '#0bbd87'
          }
        })
      } else {
        this.fetchData();
      }
    },
    fetchData() {
      this.$api.queryExpressDelivery({ id: this.id, express_no: this.row.express_no }).then(res => {
        if (res.code == 1) {
          this.activities = res.data.Traces.map(item => {
            return {
              content: item.AcceptStation,
              timestamp: item.AcceptTime
            }
          })
        } else {
          this.$message.error(res.message)
          this.msg = res.message
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    closeDialog() {
      this.isDialog = false
      this.$emit('closeDialog', {
        isClose: true
      })
    }
  }
}
</script>

<style>
.bg-ll {
  background-color: #ECF6FF;
}

.lab-ti {
  width: 100px;
}

.conditions-prepend {
  width: 200px;
  text-align: center;
}

.conditions-append {
  width: 50px;
  text-align: center;
}

.scroll-wrap::-webkit-scrollbar {
  width: 8px;
}

.scroll-wrap::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.scroll-wrap::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

.scroll-wrap::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
